define('ANSI/Components/Feature/CookieBanner',[
        'jquery'
    ],
    function ($) {

        function InitializeCookieBanner(necessaryCookies) {
            var cookieBanner = $('.cookie-banner');
            var footer = $('.score-footer');
            var adjustMargin = cookieBanner.outerHeight();
            $('#acceptButton').on('click',
                function () {
                    footer.addClass( 'no-banner' );
                    setCookiSettings('allCookies');
                    cookieBanner.hide();
                    
                    // Reload page as all js scripts/javascript code in Site Header/Footer Scripts or 
                    // Page Header/Footer scripts is not loaded before user accepted cookies.
                    location.reload();
                });

            $('#noAcceptButton').on('click',
                function () {
                    footer.addClass('no-banner');
                    setCookiSettings('necessaryCookies');
                    cookieBanner.hide();
                    
                });

            // Removing Hashtags, Anchors, and Tracking Codes from addThis URLs
            window.addthis_config = window.addthis_config || {};
            window.addthis_config.data_track_addressbar = false;
            window.addthis_config.data_track_clickback = false;

            var cookieSetting = getCookieValue('CookieSettings');
            if ( cookieSetting !== 'allCookies' ) {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {

                    var cookieName = cookies[i].split('=')[0].trim();
                    if ( !checkIsCookieNecessary(cookieName, necessaryCookies) ) {
                        deleteCookie(cookieName);
                    }
                }
            } else {
                window.addthis_config.data_track_addressbar = true;
                window.addthis_config.data_track_clickback = true;
            }


            if ( cookieSetting === 'allCookies' || cookieSetting === 'necessaryCookies' ) {
                cookieBanner.hide();
                footer.addClass( 'no-banner' );


            } else {
                cookieBanner.show();
                footer.removeClass( 'no-banner' );
                $( '.score-footer' ).css('margin-bottom', adjustMargin + 'px');

            }

            var cookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') ||
                Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');

            if ( cookieDesc && cookieDesc.configurable ) {
                Object.defineProperty(document,
                    'cookie',
                    {
                        get: function () {
                            return cookieDesc.get.call(document);
                        },
                        set: function (value) {
                            var cookieElements = value.split('=');
                            if ( cookieElements.length === 0 )
                                return true;
                            if ( cookieSetting === 'allCookies' ||
                                checkIsCookieNecessary(cookieElements[0], necessaryCookies) ) {
                                cookieDesc.set.call(document, value);
                            }
                            return true;
                        }
                    });
            }
        }

        function setCookiSettings(value) {
            var cookieDate = new Date;
            cookieDate.setFullYear(cookieDate.getFullYear() + 1);
            var cookie = 'CookieSettings=' + value + ';expires=' + cookieDate.toGMTString() + '; path=/';
            document.cookie = cookie;
        }

        function getCookieValue(name) {
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            if ( parts.length === 2 ) {
                return parts.pop().split(';').shift();
            }
            return '';
        }

        function checkIsCookieNecessary(name, necessaryCookies) {
            var cookieIsNecessary = false;
            $.each(necessaryCookies,
                function (index, value) {
                    if ( value === name ) {
                        cookieIsNecessary = true;
                    }
                });
            return cookieIsNecessary;
        }

        function deleteCookie(name) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
        }

        return function init(args) {
            if ( args.IsEditorEditing || (typeof window.Sitecore != typeof void 0 && window.Sitecore.PageModes != typeof void 0 && window.Sitecore.PageModes != null && window.Sitecore.PageModes.PageEditor != null) ) {
                //run only in preview and frontend
                return;
            }

            return new InitializeCookieBanner(
                args.NecessaryCookies
            );
        };
    });
